import { render, staticRenderFns } from "./isBuilding.vue?vue&type=template&id=e2e0799e&scoped=true"
import script from "./isBuilding.vue?vue&type=script&lang=js"
export * from "./isBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e0799e",
  null
  
)

export default component.exports